import type WebhookModel from '@src/service/model/WebhookModel'

import Repository from './base'

export class WebhooksRepository extends Repository<WebhookModel> {}
